import Backbone from 'backbone';

export default class Paginator extends Backbone.Model {
  initialize(options) {
    this.collection = options.collection;
  }
}


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/backbone/models/Paginator.js
 **/